module.exports = __webpack_public_path__ + "img/play.adb0a6e1.webp";